import http from './http';

export default {
  // 获取题目列表
  getList(params) {
    return http.get('/o1/question_controller/index', params);
  },

  // 按题库获取题目列表
  getByBank(params) {
    return http.get('/o1/question_controller/by_bank', params);
  },

  // 获取题目详情
  getDetail(id) {
    return http.get('/o1/question_controller/read', { id });
  },

  // 创建题目
  create(data) {
    // 如果有section_id和paper_id，说明是试卷题目，使用专门的接口
    if (data.section_id && data.paper_id) {
      return http.post('/o1/question_controller/save_paper_question', data);
    }
    // 否则使用普通题库题目接口
    return http.post('/o1/question_controller/save', data);
  },

  // 更新题目
  update(id, data) {
    // 如果有section_id和paper_id，说明是试卷题目，使用专门的接口
    if (data.section_id && data.paper_id) {
      return http.post('/o1/question_controller/save_paper_question', { id, ...data });
    }
    // 否则使用普通题库题目接口
    return http.post('/o1/question_controller/save', { id, ...data });
  },

  // 删除题目
  delete(id, isPaperQuestion = false) {
    if (isPaperQuestion) {
      return http.post('/o1/question_controller/delete_paper_question', { id });
    }
    return http.post('/o1/question_controller/delete', { id });
  },

  // 批量删除题目
  batchDelete(ids) {
    return http.post('/o1/question_controller/batch_delete', { ids });
  },

  // 获取题目类型选项
  getTypeOptions() {
    return http.get('/o1/question_controller/get_type_options');
  },

  // 获取难度选项
  getDifficultyOptions() {
    return http.get('/o1/question_controller/get_difficulty_options');
  },

  // 获取题目统计信息
  getStatistics(params = {}) {
    return http.get('/o1/question_controller/statistics', params);
  },

  // 批量导入题目
  import(file, bankId) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('bank_id', bankId);
    return http.upload('/o1/question_import/import', formData);
  },

  // 根据大题ID获取题目列表
  getBySectionId(sectionId) {
    return http.get('/o1/question_controller/by_section', { section_id: sectionId });
  },

  // 导出题目
  export(params = {}) {
    // 默认导出为Excel格式
    if (!params.format) {
      params.format = 'xlsx';
    }
    return http.post('/o1/question_controller/export', params, {
      responseType: 'blob'
    });
  },

  // 下载导入模板
  downloadTemplate(type = 'xlsx') {
    return http.download('/o1/question_controller/download_template', { type });
  },

  // 下载字段映射说明
  downloadMappingGuide() {
    return http.download('/o1/question_controller/download_mapping_guide');
  },

  // 批量从题库导入题目
  batchImportFromBank(data) {
    return http.post('/o1/question_controller/batch_import_from_bank', data);
  }
};